import {
  Dialog, DialogContent, DialogTitle, Grid, Paper, styled, Table, TableBody, TableCell, tableCellClasses,
  TableContainer, TableHead, TablePagination, TableRow, Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Home from "../../home/Home";
import BillingReportsService from "../../../Services/Reports/BillingReportsService";
import Snackbar from '../../Snacbar'
import { getDate, getUserId } from '../../Utils/Common';
import { useEffect } from "react";
import HashLoader from "react-spinners/HashLoader";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: 'black',
    textAlign: "center",
    fontFamily: 'Times New Roman',
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: 'Times New Roman',
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  border: '1px solid black',
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
}));
function ConsoleBillInvoiceReport() {
  const mystyle = {
    border: " 1px solid black",
    width: "10rem",fontFamily: 'Times New Roman',
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "#0b64c5",fontFamily: 'Times New Roman',
  };
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState('');
  const [FilteredDetails, setFilteredDetails] = useState([])
  const [FilteredDetails2, setFilteredDetails2] = useState([])
  const [loading, setloading] = useState(false)
  const [showPros, setshowPros] = useState(false)
  const [refreshPros, setrefreshPros] = useState(false)
  const [dwnldBillSumryPdfPros, setdwnldBillSumryPdfPros] = useState(false)
  const [dwnldBillDetailsPdfPros, setdwnldBillDetailsPdfPros] = useState(false)

  const [details1, setdetails1] = useState([]);
  const [details2, setdetails2] = useState([]);
  const [details3, setdetails3] = useState([]);
  const [details4, setdetails4] = useState([]);
  const [downlBillsumaryOpen, setdownlBillsumaryOpen] = useState(false)
  const [cons_values, setcons_values] = useState({
    fromdate: getDate(),
    todate: getDate(),
    partyName: '',
    branch: '',
  });
  const [consDialogRemarksValues, setconsDialogRemarksValues] = useState('');
  const fromhandlechange = (e) => {
    setcons_values({ ...cons_values, fromdate: e.target.value })
  };
  const tohandlechange = (e) => {
    setcons_values({ ...cons_values, todate: e.target.value })
  };
  const partyhandlechange = (e) => {
    setcons_values({ ...cons_values, partyName: e.target.value })
    let details = { importer_iec_no: e.target.value, importer_name: '-1', branchSlNo: '-1' }
    BillingReportsService.getImporterBranch(details).then(res => {
      setdetails2(res.data);
    })
  };
  const branchhandlechange = (e) => {
    setcons_values({ ...cons_values, branch: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const consDialogRemarksOnchange = (e) => {
    setconsDialogRemarksValues(e.target.value);
  }
  ////
  const handleClose = () => {
    setOpen(false)
  }
  const dwnldInvSumaryOnClickOpen = () => {
    setdwnldBillSumryPdfPros(true)
    setdownlBillsumaryOpen(true)
    setdwnldBillSumryPdfPros(false)
  }
  const dwnldInvSumaryOnClickClose = () => {
    setdownlBillsumaryOpen(false)
  }
  //keydown
  const fromdatekeydown = (e) => {
    if (e.key === 'Enter') {
      document.getElementById('todate').focus()
    }
  }
  const todatekeydown = (e) => {
    if (e.key === 'Enter') {
      document.getElementById('code').focus()
    }
  }
  const partynamekeydown = (e) => {
    if (e.key === 'Enter') {
      document.getElementById('branchid').focus()
    }
  }
  ////validation
  const validation = () => {
    if (cons_values.partyName !== '') {
      if (cons_values.branch !== '') {
        return true;
      } else {
        setMessage('Please Select Branch Name', 'Warning ..!!');
        setseverit('warning');
        setOpen(true);
        setshowPros(false)
        setloading(false)
        document.getElementById('code').focus();
      }
    } else {
      setMessage('Please Select Party Name', 'Warning ..!!');
      setseverit('warning');
      setOpen(true);
      setshowPros(false)
      setloading(false)
      document.getElementById('code').focus();
    }
    return false;
  }
  ///getfunctions=====>
  const getImportername = () => {
    let details = { importer_iec_no: '-1', importer_name: '-1', flag: 3, }
    BillingReportsService.getImporter(details).then(res => {
      setdetails1(res.data);
    })
  }
  const getCombinedInvoiceSummary = () => {
    if (validation() === true) {
      console.log('fhsdsj')
      let details = { fromDate: cons_values.fromdate, toDate: cons_values.todate, iecNo: cons_values.partyName, branchId: cons_values.branch }
      BillingReportsService.getCombinedInvoiceSummary(details).then(res => {
        const data = res.data;
        const details = data.map((res) => res)
        if (details[0] === [] || !details[0]) {
          setMessage('No Data Found For Bill Summary!!')
          setseverit('warning')
          setOpen(true)
          setshowPros(false)
          setloading(false)
        } else {
          setdetails3(res.data);
          setFilteredDetails(res.data);
          setshowPros(false)
          setloading(false)
        }
      })
    }
  }
  const getCombinedInvoiceDetails = () => {
    if (validation() === true) {
      let details = { fromDate: cons_values.fromdate, toDate: cons_values.todate, iecNo: cons_values.partyName, branchId: cons_values.branch }
      BillingReportsService.getCombinedInvoiceDetails(details).then(res => {
        if (details[0] === [] || !details[0]) {
          setMessage('No Data Found For Bill Details!!')
          setseverit('warning')
          setOpen(true)

          setshowPros(false)
          setloading(false)
        } else {
          setdetails4(res.data);
          setFilteredDetails2(res.data);

          setshowPros(false)
          setloading(false)
        }
      })
    }
  }
  ///buttonOperations======>
  const showOnClick = () => {
    setshowPros(true)
    setloading(true)
    setPage(0)
    setPage2(0)
    getCombinedInvoiceSummary();
    getCombinedInvoiceDetails();
  }
  //refresh==============>
  const refreshOnClick = () => {
    setrefreshPros(true)
    setPage(0)
    setPage2(0)
    setshowPros(false)
    setcons_values({ ...cons_values, partyName: '', branch: '', fromdate: getDate(), todate: getDate() })
    setdetails3([]);
    setFilteredDetails([])
    setFilteredDetails2([])
    setdetails4([]);
    setrefreshPros(false)
  }
  ///downloadcopybtn============>
  const DownldBillCopyBtn = () => {
    if (validation() === true) {
      let details = { fromDate: cons_values.fromdate, toDate: cons_values.todate, iecNo: cons_values.partyName, createdBy: getUserId(), remarks: consDialogRemarksValues, }
      BillingReportsService.combinedInvoiceSummaryPdf(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank");
        window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");

      })
    }
  }
  const DownldBillDetailpdfBtn = () => {
    setdwnldBillDetailsPdfPros(true)
    if (validation() === true) {
      let details = { fromDate: cons_values.fromdate, toDate: cons_values.todate, iecNo: cons_values.partyName, branchId: cons_values.branch }
      BillingReportsService.combinedInvoiceDetailsPdf(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank");
        window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");
      })
    }
    setdwnldBillDetailsPdfPros(false)
  }
  useEffect(() => {
    setloading(true)
    setTimeout(() => {
      setloading(false)
    }, 1000)
    getImportername();
  }, []);

  // /serach table
  const descriptionSrch = () => {
    return <input style={{ width: '60px', textAlign: 'center', fontSize: '12px' }} placeholder="Search" onChange={(e) => { descriptionSrchOnchange(e.target.value) }} />
  }
  const jobnoSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search" onChange={(e) => { jobnoSrchOnchange(e.target.value) }} />
  }
  const invoicenoSrch = () => {
    return <input style={{ width: '90px', textAlign: 'center', fontSize: '12px' }} placeholder="Search" onChange={(e) => { invoicenoSrchOnchange(e.target.value) }} />
  }
  const descriptionSrchOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.billName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const jobnoSrchOnchange = (searchedVal) => {
    const filteredvalue = details4.filter((trns) => {
      return trns.consignemtNo.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue < 1) {
      setFilteredDetails2(details4)
    } else {
      setFilteredDetails2(filteredvalue)
    }
  }
  const invoicenoSrchOnchange = (searchedVal) => {
    const filteredvalue = details4.filter((trns) => {
      return trns.invoiceNo.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue < 1) {
      setFilteredDetails2(details4)
    } else {
      setFilteredDetails2(filteredvalue)
    }
  }
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }
  //dailogbox 2

  const [page2, setPage2] = React.useState(0);
  const [rowsPerPage2, setRowsPerPage2] = React.useState(10);

  const handleChangePage2 = (event, newPage) => {
    setPage2(newPage);
  }
  const handleChangeRowsPerPage2 = (event) => {
    setRowsPerPage2(parseInt(event.target.value, 10));
    setPage2(0);
  }
  return (
    <div>
      <div>
        {/* ///downloadBillSUmmarypdf */}
        <Dialog open={downlBillsumaryOpen} onClose={dwnldInvSumaryOnClickClose}>
          <DialogTitle style={mystyle1}>Remarks</DialogTitle>
          <DialogContent>
            <Form.Control style={{fontFamily: 'Times New Roman',}} value={consDialogRemarksValues} onChange={consDialogRemarksOnchange} as={'textarea'} rows={4} />
          </DialogContent>
          <center><Button variant="primary" style={{ fontFamily: 'Times New Roman',width: '150px' }} className=" mt-1 mb-1" size="sm" onClick={DownldBillCopyBtn}>Download Bill Copy</Button></center>
        </Dialog>
        {/* ////// */}
        <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
      </div>

      {/* ///////////////////////inputs/............................................... */}
      <Home />
      <div style={{ paddingLeft: '80px' }} className='container1'>
        {loading ?
          <div className="loaderCss">
            <HashLoader
              color={"#296cbc"}
              loading={loading}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
          :
          <ItemPap>
            <div className='Billingtitleclr' style={{ fontFamily: 'Times New Roman',color: 'red', fontWeight: 'bold', fontSize: '25px', marginTop: '1%', marginBottom: '1%', }}><center>CONSOLE BILL INVOICE REPORT</center></div>
            <Row>
              <Col></Col>
              <Col><center>
                <label style={mystyle1}>FromDate</label>
                <Form.Control size="sm" type="date" style={mystyle} value={cons_values.fromdate}
                  onChange={fromhandlechange} onKeyDown={fromdatekeydown} />
              </center></Col>
              <Col><center>
                <label style={mystyle1}>ToDate</label>
                <Form.Control size="sm" id='todate' type="date" style={mystyle} value={cons_values.todate}
                  onChange={tohandlechange} onKeyDown={todatekeydown} />
              </center></Col>
              <Col><center>
                <label style={mystyle1}>PartyName</label>
                <Form.Select id="code" type="text" list="code" style={mystyle} size="sm" value={cons_values.partyName}
                  onChange={partyhandlechange} onKeyDown={partynamekeydown}>
                  <option></option>
                  {details1.map(trns => (
                    <option value={trns.importer_iec_no}>{trns.importer_name}</option>
                  ))}
                </Form.Select>
              </center></Col>
              <Col><center>
                <label style={mystyle1}>Branch</label>
                <Form.Select type="text" id='branchid' list="code" style={mystyle} size="sm"
                  value={cons_values.branch} onChange={branchhandlechange}>
                  <option></option>
                  {details2.map(trns => (
                    <option value={trns.branchSlNo}>{trns.importerState}</option>
                  ))}
                </Form.Select>
              </center></Col>
              <Col></Col>
            </Row>
            <br></br>
            <Row>
              <Col lg={2}></Col>
              <Col lg={8}>
                <Button style={{fontFamily: 'Times New Roman'}} variant="primary" size="sm" onClick={showOnClick}>{showPros ? 'processing...' : 'Show'}</Button>{" "}
                <Button style={{fontFamily: 'Times New Roman'}}variant="secondary" size="sm" onClick={refreshOnClick}>{refreshPros ? 'processing...' : 'Refresh'}</Button>{" "}
                <Button style={{fontFamily: 'Times New Roman'}}variant="success" size="sm" onClick={dwnldInvSumaryOnClickOpen}>{dwnldBillSumryPdfPros ? 'processing...' : 'Download Bill Summary PDF'}</Button>{" "}
                <Button style={{fontFamily: 'Times New Roman'}}variant="success" size="sm" onClick={DownldBillDetailpdfBtn}>{dwnldBillDetailsPdfPros ? 'processing...' : 'Download Bill Details PDF'}</Button>
              </Col>
              <Col lg={2}></Col>
            </Row>
            <br></br>
            <Grid container>
              <Grid xs={6}>
                <ItemPap1>
                  <Typography style={{fontFamily: 'Times New Roman'}} className="bg-light" color={"darkblue"} fontWeight={"bolder"} variant={"h6"}>
                    BILL SUMMARY
                  </Typography>
                  <TableContainer sx={{ height: 329 }} className="bg-light">
                    <Table stickyHeader className="table table-bordered">
                      <TableHead>
                        <StyledTableRow>
                          <StyledTableCell>SlNo</StyledTableCell>
                          <StyledTableCell>Description{descriptionSrch()}</StyledTableCell>
                          <StyledTableCell>NonTaxableValue</StyledTableCell>
                          <StyledTableCell>TaxableValue</StyledTableCell>
                          <StyledTableCell>CGST_Amt</StyledTableCell>
                          <StyledTableCell>SGST_Amt</StyledTableCell>
                          <StyledTableCell>Total_Amt</StyledTableCell>
                        </StyledTableRow>
                      </TableHead>
                      <TableBody>
                        {FilteredDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          .map((trns, index) => (
                            <TableRow hover>
                              <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.serialNumber}</TableCell>
                              <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.billName}</TableCell>
                              <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.nonTaxableValue}</TableCell>
                              <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.taxableValue}</TableCell>
                              <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.cgstAmt}</TableCell>
                              <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.sgstAmt}</TableCell>
                              <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totalBillAmount}</TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    showFirstButton
                    showLastButton
                    component='div'
                    count={FilteredDetails.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onChangeRowsPerpage={handleChangeRowsPerPage}
                  />
                </ItemPap1>
              </Grid>
              <Grid xs={6}>
                <ItemPap1>
                  <Typography className="bg-light" color={"darkblue"} fontWeight={"bolder"} variant={"h6"}>
                    BILL DETAILS
                  </Typography>
                  <TableContainer sx={{ height: 325 }} className="mt-1 bg-light">
                    <Table stickyHeader className="table table-bordered">
                      <TableHead>
                        <StyledTableRow>
                          <StyledTableCell>SlNo</StyledTableCell>
                          <StyledTableCell>JobNo {jobnoSrch()}</StyledTableCell>
                          <StyledTableCell>InvoiceNo {invoicenoSrch()}</StyledTableCell>
                          <StyledTableCell>Date</StyledTableCell>
                          <StyledTableCell>ContainerSize</StyledTableCell>
                          <StyledTableCell>GSP_Receipt</StyledTableCell>
                          <StyledTableCell>GSP_PreShipment</StyledTableCell>
                          <StyledTableCell>EDI_Charge</StyledTableCell>
                          <StyledTableCell>Doc/Proc/Ex</StyledTableCell>
                          <StyledTableCell>Container_Ex</StyledTableCell>
                          <StyledTableCell>Value_Added_Service</StyledTableCell>
                          <StyledTableCell>OT_Charge</StyledTableCell>
                          <StyledTableCell>Agency_Charge</StyledTableCell>
                        </StyledTableRow>
                      </TableHead>
                      <TableBody>
                        {FilteredDetails2.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          .map((trns, index) => (
                            <TableRow hover key={trns.serialNumber}>
                              <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.serialNumber}</TableCell>
                              <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.consignemtNo}</TableCell>
                              <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceNo}</TableCell>
                              <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceDate}</TableCell>
                              <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.containerSize}</TableCell>
                              <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.gspReceipt}</TableCell>
                              <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.gspPreshipment}</TableCell>
                              <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.ediCharge}</TableCell>
                              <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.docProcExCharge}</TableCell>
                              <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.containerExCharge}</TableCell>
                              <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.valAddedCharge}</TableCell>
                              <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.otCharge}</TableCell>
                              <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.agencyCharge}</TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    showFirstButton
                    showLastButton
                    component='div'
                    count={FilteredDetails2.length}
                    rowsPerPage={rowsPerPage2}
                    page={page2}
                    onPageChange={handleChangePage2}
                    onChangeRowsPerpage={handleChangeRowsPerPage2}
                  />
                </ItemPap1>
              </Grid>
            </Grid>
          </ItemPap>}
      </div>
    </div >
  );
}

export default ConsoleBillInvoiceReport;
